<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-md-5">
                    <change-password-notice-card></change-password-notice-card>
                </div>
                <div class="col-md-7">
                    <change-password-card></change-password-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ChangePasswordCard from './components/ChangePasswordCard'
    import ChangePasswordNoticeCard from './components/ChangePasswordNoticeCard'

    export default {

        components: {
            ChangePasswordCard, ChangePasswordNoticeCard
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('auth.change-password'),
                    },
                ]
            }
        },
    }
</script>
